import { AppInstance } from "./instance";

export const ratingReviewApi = {
  getMyReview: (orderItemId) =>
    AppInstance.get("/rating-review/my-review", {
      params: { order_item_id: orderItemId },
    }),

  upsertReview: ({ order_item_id, rating, review }) =>
    AppInstance.post("/rating-review", {
      order_item_id,
      rating,
      review,
    }),

  getVariantReviews: (variantId, page = 1) =>
    AppInstance.get("/rating-review", {
      params: { variant_id: variantId, page },
    }),
};
